import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import {
    TextField,
    Box,
    Backdrop,
    Stack,
    InputLabel,
    MenuItem,
    FormControl,
    Select
} from '@mui/material';

import CustomButton from '../custom_components/CustomButton';
import CustomModalHeader from '../custom_components/CustomModalHeader';

const apiUrl = process.env.REACT_APP_API_URL;

const EditArrivedList = ({
    open,
    onClose,
    list,
    onUpdate,
}) => {

    const [listId, setListId] = useState("");
    const [listName, setListName] = useState("");
    const [listCargo, setListCargo] = useState("");
    const [listDate, setListDate] = useState("");

    const [isSaving, setIsSaving] = useState(false);

    // INITIALIZED
    useEffect(() => {
        if (!open) return;

        setListId(list?.ListID || "");
        setListName(list?.ListName || "");
        setListCargo(list?.Cargo || "");
        setListDate(list?.DateArrived || "");
        
    }, [open]);

    // SAVE EDIT ARRIVED LIST
    const handleEditList = async () => {

        if (!listId || !listName, !listDate, !listCargo) {
            Swal.fire({
                text: "Please fill all the required inputs.",
                icon: "warning"
            });
            return;
        }

        setIsSaving(true);

        try {
            const response = await fetch(
                `${apiUrl}manage_arrived/edit_arrived_list.php`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        listId: listId,
                        listName: listName,
                        cargo: listCargo,
                        dateArrived: listDate,
                    })
                });

            const result = await response.json();

            if (result.status === 'success') {

                onUpdate({
                    ListID: listId,
                    listName: listName,
                    listCargo: listCargo,
                    listDate: listDate,
                });

                Swal.fire({
                    icon: "success",
                    text: result.message,
                    timer: 3500,
                    showConfirmButton: false,
                });

                setListId("");
                setListName("");
                setListCargo("");
                setListDate("");
                onClose();

            } else if (result.status === 'warning') {
                Swal.fire({
                    text: result.message,
                    icon: "error"
                });
            }

        } catch (error) {
            Swal.fire({
                title: 'Error saving list!',
                text: error,
                icon: "error"
            });
            console.error('Error updating list:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                    width: 420,
                    backgroundColor: "#ffffff",
                    borderRadius: 2,
                    p: 2.5,
                    boxShadow: 6,

                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >

                <CustomModalHeader
                    title="Edit List"
                    subtitle={`ID: ${listId || ""}`}
                    onClose={onClose}
                />

                <Stack spacing={2.2}>
                    <TextField
                        label="List Name"
                        size='small'
                        value={listName}
                        onChange={(e) => setListName(e.target.value)}
                    />

                    <FormControl
                        sx={{ backgroundColor: 'white', borderRadius: 1 }}
                        size="small"
                    >
                        <InputLabel id="select-cargo">
                            Cargo Type
                        </InputLabel>
                        <Select
                            labelId="select-cargo"
                            id="demo-select-small"
                            value={listCargo}
                            label="Cargo Type"
                            onChange={(e) => setListCargo(e.target.value)}
                        >
                            <MenuItem value="Sea Cargo">Sea Cargo</MenuItem>
                            <MenuItem value="Air Cargo">Air Cargo</MenuItem>
                            <MenuItem value="PH">PH</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        label="Date"
                        type="date"
                        size="small"
                        fullWidth
                        value={listDate}
                        onChange={(e) => setListDate(e.target.value)}
                    />
                </Stack>

                <Stack
                    direction="row"
                    justifyContent="right"
                    gap={2}
                    mt={4}
                >
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={onClose}
                    />

                    <CustomButton
                        label={isSaving ? "Updating..." : "Save Changes"}
                        disabled={isSaving}
                        onClick={handleEditList}
                    />
                </Stack>

            </Box>

        </Backdrop>
    );
};

export default EditArrivedList;
